import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const saveSearchKeywordKbArticle = createAsyncThunk(
  'kbSearchArticlesExternal/saveSearchKeywordKbArticle',
  async ({ businessName, search, group_id }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${ROOT_URL}/kb/${businessName}/search`, {
        query: search,
        group_id,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
};

const kbSearchArticlesExternalSlice = createSlice({
  name: 'kbSearchArticlesExternal',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveSearchKeywordKbArticle.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveSearchKeywordKbArticle.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        // fire & forget — no state to update, just saving the keyword
      })
      .addCase(saveSearchKeywordKbArticle.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError } = kbSearchArticlesExternalSlice.actions;

export default kbSearchArticlesExternalSlice.reducer;